// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rC2B","label":"styles_label__3Mn_a"};